<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>المخازن</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة مخزن</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        disabled
                        v-model="mycode"
                        label="كود المخزن"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.code')"
                        data-vv-name="code"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.name"
                        label="أسم المخزن"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.address"
                        label=" العنوان"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_branch"
                        :items="branchs"
                        item-text="name"
                        item-value="id"
                        label="أختر الفرع"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_employer"
                        :hint="
                          `${select_employer.job_name}, ${select_employer.name}`
                        "
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر  الموظف المسئول"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_mohafza"
                        :items="mohafzas"
                        item-text="name"
                        item-value="id"
                        label="أختر المحافظة"
                        persistent-hint
                        return-object
                        single-line
                        @change="getCities(select_mohafza.id)"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.mohafza')"
                        data-vv-name="mohafza"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_city"
                        :items="cities"
                        item-text="name"
                        item-value="id"
                        label="أختر المدينة"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.job')"
                        data-vv-name="job"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل مخزن</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      disabled
                      v-model="editedItem.code"
                      label="كود المخزن"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.code')"
                      data-vv-name="code"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.name"
                      label="أسم المخزن"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.address"
                      label="العنوان "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_branch_edit"
                      :items="branchs"
                      item-text="name"
                      item-value="id"
                      label="أختر الفرع"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form2"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_employer_edit"
                      :hint="
                        `${select_employer_edit.job_name}, ${
                          select_employer_edit.name
                        }`
                      "
                      :items="employers"
                      item-text="name"
                      item-value="id"
                      label="أختر  الموظف المسئول"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form2"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_mohafza_edit"
                      :items="mohafzas"
                      item-text="name"
                      item-value="id"
                      label="أختر المحافظة"
                      persistent-hint
                      return-object
                      single-line
                      @change="getCities(select_mohafza_edit.id)"
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_city_edit"
                      :items="cities"
                      item-text="name"
                      item-value="id"
                      label="أختر المدينة"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="stores"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.address }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              class="ml-4"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  stores,
  add_store,
  update_store,
  delete_store,
  branches,
  employers,
  mohafzas,
  cities
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "أسم المخزن",
        align: "right",
        value: "name"
      },
      { text: "العنوان", value: "address", align: "right" },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],
    select_branch: { id: "", job_name: "", name: "أختر الفرع" },
    select_employer: { id: "", job_name: "", name: "أختر الموظف المسئول " },
    select_mohafza: { id: "", name: "أختر المحافظة" },
    select_city: { id: "", name: "أختر المدينة" },
    select_branch_edit: { id: "", job_name: "", name: "أختر الفرع" },
    select_employer_edit: {
      id: "",
      job_name: "",
      name: "أختر الموظف المسئول "
    },
    select_mohafza_edit: { id: "", name: "أختر المحافظة" },
    select_city_edit: { id: "", name: "أختر المدينة" },
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    stores: [],
    branchs: [],
    employers: [],
    mohafzas: [],
    cities: [],
    editedItem: {
      id: "",
      code: "",
      name: "",
      address: "",
      mohafza_id: "",
      city_id: "",
      branch_id: "",
      employe_responsible_id: ""
    },
    newItem: {
      id: "",
      code: "",
      name: "",
      address: "",
      mohafza_id: "",
      city_id: "",
      branch_id: "",
      employe_responsible_id: ""
    }
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.stores.length > 0) {
        return (this.code =
          parseInt(this.stores[this.stores.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      branches().then(response => {
        this.branchs = response.data;
      });

      employers().then(response => {
        this.employers = response.data;
      });

      stores().then(response => {
        this.stores = response.data;
        this.pagination.totalItems = response.data.length;
        this.loading = false;
      });

      mohafzas().then(response => {
        this.mohafzas = response.data;
      });
    },
    getCities(id) {
      cities(id).then(response => {
        this.cities = response.data;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      this.editedIndex = this.stores.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.name = item.name;
      this.editedItem.address = item.address;
      this.select_branch_edit = item.branch;
      this.select_mohafza_edit = item.mohafza;
      this.getCities(item.mohafza.id);
      this.select_city_edit = item.city;
      this.select_employer_edit = item.employer;
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.stores.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_store(frmData2, item.id).then(response => {
            this.loading = false;
            this.stores.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.newItem.code = this.code;
          this.newItem.branch_id = this.select_branch.id;
          this.newItem.mohafza_id = this.select_mohafza.id;
          this.newItem.city_id = this.select_city.id;
          this.newItem.employe_responsible_id = this.select_employer.id;
          var frmData = new FormData();
          frmData.append("store", JSON.stringify(this.newItem));

          add_store(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_branch, this.$options.data().select_branch);
            // Object.assign(this.$data.select_mohafza, this.$options.data().select_mohafza);
            // Object.assign(this.$data.select_city, this.$options.data().select_city);
            // Object.assign(this.$data.select_employer, this.$options.data().select_employer);
            this.stores.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;

          this.editedItem.branch_id = this.select_branch_edit.id;
          this.editedItem.mohafza_id = this.select_mohafza_edit.id;
          this.editedItem.city_id = this.select_city_edit.id;
          this.editedItem.employe_responsible_id = this.select_employer_edit.id;

          var frmData = new FormData();
          frmData.append("store", JSON.stringify(this.editedItem));
          update_store(frmData, item_id).then(response => {
            Vue.set(
              this.stores,
              this.stores.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
table.v-table tbody td {
  font-size: 17px;
}
</style>
